export const ITEM_LIST_ID = "search";
export const ITEM_LIST_NAME = "search_result_page";
export const SELECT_CONTENT = "select_content";
export const DESELECT_CONTENT = "deselect_content";
export const SELECT_ITEM = "select_item";
export const VIEW_SLIDER_IMAGE = "view_slider_image";
export const SEARCH = "search";
export const VIEW_ITEM_LIST = "view_item_list";
